module.exports = __webpack_public_path__ + "img/Bastelbett.bc1c7332.jpg";